import React, { useState, useEffect, useId, useRef } from "react";
import ImageBlock from "./image-block/image-block";
import { ReactComponent as ImageIcon } from 'assets/icons/image.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import { StandartButton } from "commons/form-controls";
import { FileUploader } from "react-drag-drop-files";
import s from "./image-component.module.scss";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";

const ImageComponent = (props) => {

  const getBase64 = (parameters) => {
    return 'data:image/'+parameters.IMAGE_FORMAT+';base64,'+parameters.IMAGE_BASE64
  }

  const [files, setFiles] = useState([]);
  const [filesSelected, onFilesSelected] = useState([]);
  const [parameters, setParameters] = useState(props.parameters ? props.parameters : null);
  const [images, setImages] = useState(props.images ? props.images : []);
  const [imagesList, setImagesList] = useState(props.parameters && props.parameters.IMAGE_BASE64 ? props.parameters.IMAGE_BASE64 : []);
  const [rerender, setRerender] = useState(false);
  const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];
  const [fileU, setFileU] = useState(null);
  const [base64, setBase64] = useState(props.parameters && props.parameters.IMAGE_BASE64 ? getBase64(props.parameters) : null);


  /*const getResult = (file, image, i) => {

    var reader = new FileReader();

    reader.onloadend = function () {
      let base = reader.result;
      let base64 = base.split(",");
      let typePrefix = base64[0].split("/");

      let type = typePrefix[1].split(";");

      image.IMAGE_BASE64 = base;
      image.IMAGE_FORMAT = type[0];
      let imagesBase = images;
      imagesBase.push(image);
      let imageType = imagesList;
      let newImage = <img src={reader.result} key={i} />
      imageType.push(newImage);
      setImagesList(imageType)
      setImages(imagesBase)
      setRerender(!rerender);
    }
    reader.readAsDataURL(file);
  }*/


  useEffect(() => {
    setFiles(files);
    setParameters(props.parameters ? props.parameters : null);
    setImagesList(props.parameters && props.parameters.IMAGE_BASE64 ? props.parameters.IMAGE_BASE64 : []);
    setBase64(props.parameters && props.parameters.IMAGE_BASE64 ? getBase64(props.parameters) : null);
  }, [files, setFiles, props]);


  /*const saveImage = () => {
      let type = 'IMAGE'
      let params = parameters;
      let baseImage = base64.split(",");
      
      let formatType = base64.split(";");
      let baseFormat = formatType[0].split("/");
      let format = base64[0].IMAGE_FORMAT;
      
      params.IMAGE_BASE64 = baseImage[1];
      params.IMAGE_FORMAT = baseFormat[1].toUpperCase();

      props.updateTemplateComponents(params, type)
  }*/

  const onDragElement = <div className={s.onDragElement}>
    <ImageIcon />
    <span>{props.getValue('UPLOAD_IMAGES')}</span>
    <span>{props.getValue('DRAG_AND_DROP_HERE')}</span>
  </div>

  const fileUploaded = <div className={s.uploadedImage}>
    <img src={ getBase64(parameters) } />
  </div>

  const laberForUpload = "LABEL TEXTSD"


  const handleChange = (file) => {
    setFileU(file);
    var reader = new FileReader();
    reader.onloadend = function () {
      let base = reader.result;
      let base64 = base.split(",");
      let image = base64[1];
      let imageData = base64[0].split(";");
      let format = imageData[0].split("/");

      let params = {...parameters};

      params.IMAGE_BASE64 = base64[1];
      params.IMAGE_FORMAT = format[1].toUpperCase();
      props.updateComponent(props.index, params);
      //setParameters(params);
    }
    reader.readAsDataURL(file);

};

const align = (align) => {
  let params = {...parameters};
  params.ALIGNMENT = align;
  props.updateComponent(props.index, params);
  setRerender(!rerender);
}

  return (
    <section className={s.ImageComponent}>
      <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
          {!parameters.IMAGE_BASE64 ? <FileUploader
                        label={laberForUpload}
                        handleChange={handleChange} 
                        name="file" 
                        types={fileTypes}
                        children={onDragElement}
                    />
                  : fileUploaded
          }
  {/* <div className={s.buttonsBlock}>
            <StandartButton title={props.getValue('SAVE')}  fill={'white'} callback={saveImage}/>
        </div> */ }
    </section> 
  );

}

export default ImageComponent;